module.exports = __webpack_public_path__ + "static/media/IMG_4532 oven module.11c027b3.JPG";